import request from '@/utils/request';

/**
 * MLS Access Requests resource — endpointy admin do zarządzania prośbami o dostęp do MLS.
 * Mirror wzorca FtpRequest endpoints w api/integration.js (getFtpRequests, approveFtpRequest, rejectFtpRequest).
 */
class MlsAccessRequestsResource {
  // Lista próśb (paginowana, filtrowana po status).
  getRequests(query) {
    return request({
      url: '/admin/mls/access-requests',
      method: 'get',
      params: query,
    });
  }

  // Liczba pending (dla badge'a w sidebarze).
  getPendingCount() {
    return request({
      url: '/admin/mls/access-requests/pending-count',
      method: 'get',
    });
  }

  // Akceptuj prośbę → backend aktywuje membership (mls_enabled=true, status=active)
  // i wysyła email + in-app notification do requestera.
  approve(id) {
    return request({
      url: '/admin/mls/access-requests/' + id + '/approve',
      method: 'post',
    });
  }

  // Odrzuć prośbę z reason → backend wysyła email z reason + in-app notification.
  reject(id, reason) {
    return request({
      url: '/admin/mls/access-requests/' + id + '/reject',
      method: 'post',
      data: { reason },
    });
  }
}

export { MlsAccessRequestsResource as default };
